import { FormattedMessage } from "react-intl";
import CustomSelect from "../CustomSelect";
import { Genders } from "~enums/genders";

const options = Object.values(Genders).map((value) => ({ value, label: <FormattedMessage id={`gender.${value}`} /> }));

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  value?: string | null;
}

const SelectGender = ({ className, disabled, onChange, value }: Props) => (
  <CustomSelect
    value={value}
    onChange={(value) => onChange?.(value as string)}
    options={options}
    placeholder={<FormattedMessage id="gender" />}
    allowClear
    className={className}
    disabled={disabled}
  />
);

export default SelectGender;
